export const getPauseBorderStyle = () => {
   var style = {
            borderRight: '2px solid rgba(255, 98, 98, 0.5)',
        borderTop: '2px solid rgba(255, 98, 98, 0.5)',
        borderLeft: '2px solid rgba(255, 98, 98, 0.5)'
        }
    return style
  }